import React from "react";

import { useTranslation } from "react-i18next";

import Checkbox from "../../../Form/Checkbox";
import { Wrapper, TableBodyWrapper, TableBodyEmptyGrid } from "./styles";

type Column = {
  title: string;
  columnName: string;
  spacingColumns?: string;
  formatComponent?: (value: string, rowIndex?: number) => React.ReactChild;
};

interface Props {
  data: any[];
  columns: Column[];
  checkField?: boolean;
  isOnViewMode?: boolean;
  selectedRow?: number[];
  isActionColumnOnEnd?: boolean;
  hasErrors?: boolean;

  onSelectRow?: (row: number) => void;
  actionColumn?: (value: number) => React.ReactChild;
}

export const UIBody = ({
  data,
  columns,
  checkField,
  isOnViewMode = false,
  selectedRow,
  onSelectRow,
  isActionColumnOnEnd = true,
  actionColumn,
  hasErrors = false,
}: Props) => {
  const { t: translate } = useTranslation();

  return (
    <Wrapper id="tableList">
      {data && data.length > 0 ? (
        data.map((item, index: number) => (
          <TableBodyWrapper
            key={index}
            checkColumn={checkField}
            isOnViewMode={isOnViewMode}
            hasErrors={hasErrors}
            spacingColumns={columns.map((column) => column.spacingColumns).join(" ")}
          >
            {checkField && (
              <div className="checkbox">
                <Checkbox
                  className="mb-0 pb-0"
                  label=""
                  checked={selectedRow?.includes(index)}
                  onChange={() => onSelectRow && onSelectRow(index)}
                />
              </div>
            )}
            {columns.map((column, columnIndex: number) => (
              <div key={columnIndex} className={column.columnName}>
                {column.formatComponent ? (
                  column.formatComponent(item[column.columnName], index)
                ) : (
                  <span>{item[column.columnName]}</span>
                )}
              </div>
            ))}
            {!isOnViewMode && (
              <div className={`action ${isActionColumnOnEnd && "text-right"}`}>
                {actionColumn && actionColumn(index)}
              </div>
            )}
          </TableBodyWrapper>
        ))
      ) : (
        <TableBodyEmptyGrid>
          <span>{translate("emptyList")}</span>
        </TableBodyEmptyGrid>
      )}
    </Wrapper>
  );
};
